import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import ApiService from "../../../services/ApiService";
import { callAlert, downloadPdfFile } from "../../../services/CommonService";
import { format } from "date-fns";
import QuizService from "../../../services/QuizService";
import { FaDownload } from "react-icons/fa6";
import Loader from "../../../features/Loader";

function Assignments() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const [quizData, setQuizData] = useState();

  const [show, setShow] = useState(false);

  function imgPDFUpload(type = "pdf", data, callback = null) {
    let formData = new FormData(); //formdata object

    formData.append("file", data); //append the values with key, value pair

    ApiService.postRequestAdmin("/file/syllabus/uploadFile", formData)
    // ApiService.postRequestAdminFile("/file/syllabus/uploadFile", formData)
      .then((res) => {
        if (res?.data) {
          callAlert("", res?.data?.data);
        } else {
          callAlert("", res?.data?.message);
        }
      })
      .catch((error) => {
        callAlert("", error?.error?.message);
      });
  }

  //   <Upload sendDataToParent={getPdfData} fileAllow="pdf" />

  function ScoreIndicator({ value, maxValue }) {
    const val = (value / maxValue) * 100;
    const deg = (180 / 100) * val;
    return (
      //   <div className="indicator">
      //     <span
      //       className={`bar ${val < 50 ? "red" : "orange"}  ${
      //         val > 80 ? "green" : ""
      //       } `}
      //       style={{ transform: `rotate(${deg}deg)` }}
      //     />
      <div className="container">
        <span
          className={`fw-bold ${val < 50 ? "text-danger" : "text-warning"}  ${
            val > 80 ? "text-primary" : ""
          } `}
        >
          <span className="">{value}</span>
          <span></span>
        </span>
      </div>
      //   </div>
    );
  }

  const downloadFile = (content) => {
    console.log("Contnet", content);
    // const pdfURL = "/quiz/downloadAssignment/" + content.assignment;
    // const pdfURL = "/file/assignments/downloadAssignment/";
    const pdfURL = "/assignments/downloadAssignment/";

    downloadPdfFile(
      pdfURL,
      content.name.replace(".pdf", ""),
      content,
      true,
      "POST"
    );
  };

  const downloadFile2 = (content) => {
    console.log("Contnet", content);
    // const pdfURL = "/quiz/downloadAssignment/" + content.assignment;

    const pdfURL =
      // "/file/assignments/downloadSolvedAssignment?assignmentId=" + content.name;
      "/assignments/downloadSolvedAssignment?assignmentId=" + content.name;

    downloadPdfFile(
      pdfURL,
      content.name.replace(".pdf", ""),
      content,
      true,
      "GET"
    );
  };
  const downloadFile3 = (content) => {
    console.log("", content);
    // const pdfURL = "/quiz/downloadAssignment/" + content.assignment;

    const pdfURL =
      // "/file/assignments/downloadReviewedAssignment?assignmentId=" + content.name;
      "/assignments/downloadReviewedAssignment?assignmentId=" + content.name;

    downloadPdfFile(
      pdfURL,
      content.name.replace(".pdf", ""),
      content,
      true,
      "GET"
    );
  };

  const columns = [
    {
      name: "Course Name",
      selector: (d) => d.courseName,
      sortable: true,
      wrap: true,
    },

    {
      name: "Module Name",
      selector: (d) => d.moduleName,
      sortable: true,
      wrap: true,
    },

    {
      name: "Assignment Name",
      selector: (d) => d.name,
      sortable: true,
      wrap: true,
    },
    {
      name: "Current Status",
      selector: (d) => d.status,
      sortable: true,
      wrap: true,
    },
    // {
    //   name: "Start Date/Time  ",
    //   selector: (d) => d.startTime,
    //   sortable: true,
    //   cell: (d) => [
    //     <div className="">
    //       {format(new Date(d.startTime), "dd/MMM hh:mm a")}
    //     </div>,
    //   ],
    // },

    // {
    //   name: "Score",
    //   // selector: (d) => d.percentage +"%",
    //   selector: "",
    //   sortable: true,
    //     // width: "170px",
    //   cell: (d) => [<ScoreIndicator value={d?.percentage} maxValue={100} />],
    // },
    // {
    //   name: "Status",
    //   selector: (d) => d.status,
    //   sortable: true,
    // },
    {
      name: "Download",
      selector: "",
      sortable: false,
      cell: (d) => [
        d.status === "DOWNLOADED" && (
          <button
            // onClick={handleClick.bind(this, d)}
            onClick={() => {
              downloadFile({
                name: d.fileName,
                courseName: d.courseName,
                videoName: d.videoName,
                moduleName: d.moduleName,
              });
            }}
            className="btn btn-primary mx-1"
            icon="edit"
            title="Download Assignment"
          >
            <FaDownload />
          </button>
        ),
        d.status === "INPROGRESS" && (
          <button
            // onClick={handleClick.bind(this, d)}
            onClick={() => {
              downloadFile2({
                name: d.id,
                courseName: d.courseName,
                videoName: d.videoName,
                moduleName: d.moduleName,
              });
            }}
            className="btn btn-primary mx-1"
            icon="edit"
            title="Download Uploaded Assignment"
          >
            <FaDownload />
          </button>
        ),
        d.status != "DOWNLOADED" && d.status != "INPROGRESS" && (
          <button
            // onClick={handleClick.bind(this, d)}
            onClick={() => {
              downloadFile3({
                name: d.id,
                courseName: d.courseName,
                videoName: d.videoName,
                moduleName: d.moduleName,
              });
            }}
            className="btn btn-success mx-1"
            icon="edit"
            title="Download Submitted Assignment"
          >
            <FaDownload />
          </button>
        ),
      ],
    },

    {
      name: "Action",
      selector: "",
      sortable: false,
      width: "300px",
      cell: (d) => [
        <>
          {d.status === "COMPLETE" && (
            // <button
            //   onClick={handleClick.bind(this, d)}
            //   className="btn btn-success links  f12"
            //   icon="edit"
            // >
            //   {" "}
            //   Download{" "}
            // </button>
            <span className="text-success f12">✅ Completed</span>
          )}
          {d.status === "DOWNLOADED" && (
            <div className="py-1">
              {!uploading ? (
                <>
                  <input
                    type="file"
                    accept=".pdf"
                    onChange={(event) => handleFileChange(event)}
                    className=""
                  />
                  <button
                    className="btn btn-sm btn-primary mt-2 f12"
                    onClick={() => handleFileUpload(d.fileName)}
                  >
                    Upload PDF
                  </button>
                </>
              ) : (
                <p>Uploading...</p>
              )}
            </div>
          )}
          {d.status === "INPROGRESS" && (
            <span className="text-success f12">🟢 Under Review</span>
          )}
        </>,
      ],
    },
  ];

  // download
  // inprogress
  // complete

  const handleClick = (quiz) => {
    QuizService.downloadReports(quiz?.id);
  };

  function tableList() {
    ApiService.publicGetRequest("/assignments/assignment-summary", true)
      .then((res) => {
        if (res.data?.resultCode == 1 || res.data?.resultCode == 404) {
          setData(res.data.data ? res.data.data : []);
          setLoading(false);
        } else {
          callAlert("", res?.message);
          setLoading(false);
        }
      })
      .catch((error) => {
        callAlert("", error?.error?.message);
        setLoading(false);
      });
  }

  const [uploading, setUploading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
  };

  const handleFileUpload = async (id) => {
    if (!selectedFile) {
      callAlert("", "Please select a file first");
      return;
    }

    setUploading(true);
    let formData = new FormData();
    formData.append("file", selectedFile);
    // ApiService.publicPostRequest(
    ApiService.publicPostRequestFile(
      // `/file/assignments/uploadSolvedAssignment?id=${id}`,
      `/assignments/uploadSolvedAssignment?id=${id}`,
      formData,
      true
    )
      .then((res) => {
        setUploading(false);
        if (res.data?.resultCode === 1) {
          callAlert("", res?.data.message, "success");
          tableList();
        } else {
          callAlert("", res?.data?.message);
        }
      })
      .catch((error) => {
        setUploading(false);
        callAlert("", error?.error?.message);
      });
  };

  useEffect(() => {
    if (loading) {
      tableList();
    }
  }, []);
  return (
    <div>
      {loading ? (
        <Loader />
      ) : (
        <DataTable
          columns={columns}
          data={data}
          progressPending={loading}
          pagination
          //className="table"
          //keys="id"
          //fixedHeader
          //selectableRows
        />
      )}
    </div>
  );
}

export default Assignments;
